import { zh_CN } from './zh_CN';
import { en_US } from './en_US';
import { ru_RU } from './ru_RU';
import { zh_HK } from './zh_HK';
import { es_ES } from './es_ES';
import { fr_FR } from './fr_FR';
import { ja_JP } from './ja_JP';
import type { AmplifierLocaleId } from '../amplifierLanguage';

export { zh_CN, en_US, ru_RU, zh_HK, es_ES, fr_FR, ja_JP };
export type { AmplifierLocale, AmplifierLocaleKey } from './zh_CN';

export const amplifierLocales: Record<AmplifierLocaleId, import('./zh_CN').AmplifierLocale> = {
  zh_CN,
  en_US,
  ru_RU,
  zh_HK,
  es_ES,
  fr_FR,
  ja_JP,
};
